/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Compliance_Pattern_TermsInputs */



/**
* | output |
* | --- |
* | "{count} terms" |
*
* @param {Compliance_Pattern_TermsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_pattern_terms = /** @type {((inputs: Compliance_Pattern_TermsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Pattern_TermsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Begriffe`)
	return /** @type {LocalizedString} */ (`${i?.count} terms`)
});